import { SkeletonText } from './skeleton-text';
import { SkeletonMedia } from './skeleton-media';
import { SkeletonCircle } from './skeleton-circle';
import { SkeletonParagraph } from './skeleton-paragraph';

export { SkeletonText, SkeletonMedia, SkeletonCircle, SkeletonParagraph };
